import { mapState } from 'vuex'
import LineScale from '@/components/line-scale/line-scale.vue'
import LineScaleComplex from '@/components/line-scale-complex/line-scale-complex.vue'
import defineManufactureMainPageMixin from '../mixins/define-manufacture-main-page'

export default {
  name: "ManufactureInfoItem",
  /**
   * метод goMainPage(manufacture_id), onContextmenuOrder(manufacture_id)
   */
  mixins: [ defineManufactureMainPageMixin ],
  props: {
    itemInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    LineScale,
    LineScaleComplex
  },
  static() {
    return {
      intensityColors: {
        low: 'green',
        medium: 'yellow',
        high: 'red'
      }
    }
  },
  data() {
    return {
      minimized: false
    }
  },
  computed: {
    ...mapState({
      globalMinimized: state => state.dashboardManufactures.mininmized
    })
  },
  methods: {
    togglefMinimized() {
      this.minimized = !this.minimized
    },
    openSettings() {
      this.$emit('open-settings', this.itemInfo.manufacture_id)
    }
  },
  watch: {
    globalMinimized: {
      immediate: true,
      handler() {
        this.minimized = this.globalMinimized
      }
    }
  }
}